import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod'

/**
 * Server-only. No `client` block: NEXT_PUBLIC_* vars are already validated here and statically
 * inlined at build time, so re-validating them in the browser would just bundle Zod for no
 * benefit — client code reads `process.env.NEXT_PUBLIC_*` directly (see src/common/config.ts).
 *
 * To skip validation (e.g. in CI): SKIP_ENV_VALIDATION=1 npm run lint
 */
export const env = createEnv({
    skipValidation: !!process.env.SKIP_ENV_VALIDATION,

    server: {
        ASSET_PREFIX: z.string(),
        BASE_PATH: z.string(),
        BASE_URL: z.string().min(1),
        BFF_BASE_URL: z.string().min(1),
        BUILD_ID: z.string().optional(),
        ENV: z.enum(['development', 'staging', 'production']),
        FASTLANE_BASE_URL: z.string().min(1),
        FASTLANE_INTERNAL_BASE_URL: z.string().min(1),
        GTM_CONTAINER_ID: z.string(),
        SENTRY_AUTH_TOKEN: z.string().optional(),
        SENTRY_DSN: z.string().optional(),
        SENTRY_ORG: z.string().optional(),
        SENTRY_PROJECT: z.string().optional(),
        SENTRY_URL: z.string().optional(),
        TEST_BASE_URL: z.string().min(1),
        GOOGLE_SITE_VERIFICATION: z.string(),
        GOOGLE_MAPS_KEY: z.string(),
        GOOGLE_EMBEDDED_MAPS_KEY: z.string(),
        HTG_PUBLIC_URL: z.string().min(1),
        GYG_PARTNER_ID: z.string().optional(),
        MEDIA_BASE_URL: z.string().min(1),
        FIREBASE_API_KEY: z.string().optional(),
        FIREBASE_APP_ID: z.string().optional(),
        FIREBASE_MESSAGING_SENDER_ID: z.string().optional(),
        FIREBASE_PROJECT_ID: z.string().optional(),
        FIREBASE_AUTH_DOMAIN: z.string().optional(),
        FIREBASE_STORAGE_BUCKET: z.string().optional(),
    },

    runtimeEnv: {
        ASSET_PREFIX: process.env.ASSET_PREFIX,
        BASE_PATH: process.env.BASE_PATH,
        BASE_URL: process.env.BASE_URL,
        BFF_BASE_URL: process.env.BFF_BASE_URL,
        BUILD_ID: process.env.BUILD_ID,
        ENV: process.env.ENV,
        FASTLANE_BASE_URL: process.env.FASTLANE_BASE_URL,
        FASTLANE_INTERNAL_BASE_URL: process.env.FASTLANE_INTERNAL_BASE_URL,
        GTM_CONTAINER_ID: process.env.GTM_CONTAINER_ID,
        SENTRY_AUTH_TOKEN: process.env.SENTRY_AUTH_TOKEN,
        SENTRY_DSN: process.env.SENTRY_DSN,
        SENTRY_ORG: process.env.SENTRY_ORG,
        SENTRY_PROJECT: process.env.SENTRY_PROJECT,
        SENTRY_URL: process.env.SENTRY_URL,
        TEST_BASE_URL: process.env.TEST_BASE_URL,
        GOOGLE_SITE_VERIFICATION: process.env.GOOGLE_SITE_VERIFICATION,
        GOOGLE_MAPS_KEY: process.env.GOOGLE_MAPS_KEY,
        GOOGLE_EMBEDDED_MAPS_KEY: process.env.GOOGLE_EMBEDDED_MAPS_KEY,
        HTG_PUBLIC_URL: process.env.HTG_PUBLIC_URL,
        GYG_PARTNER_ID: process.env.GYG_PARTNER_ID,
        MEDIA_BASE_URL: process.env.MEDIA_BASE_URL,
        FIREBASE_API_KEY: process.env.FIREBASE_API_KEY,
        FIREBASE_APP_ID: process.env.FIREBASE_APP_ID,
        FIREBASE_MESSAGING_SENDER_ID: process.env.FIREBASE_MESSAGING_SENDER_ID,
        FIREBASE_PROJECT_ID: process.env.FIREBASE_PROJECT_ID,
        FIREBASE_AUTH_DOMAIN: process.env.FIREBASE_AUTH_DOMAIN,
        FIREBASE_STORAGE_BUCKET: process.env.FIREBASE_STORAGE_BUCKET,
    },
})
